<svelte:options customElement={{ tag: "bt-flash-container", shadow: "none" }} />

<script lang="ts">
  import { onMount } from 'svelte';
  import { fade, fly } from 'svelte/transition';
  import { eventBus } from '$shared/lib/eventBus';

  // Rails flash items passed as a JSON attribute from the layout.
  // Each item: { type: string, message: string }
  export let flashes: string = '[]';

  interface FlashItem {
    id: number;
    type: string;
    message: string;
  }

  let items: FlashItem[] = [];
  let nextId = 0;

  function borderColor(type: string): string {
    if (type === 'notice' || type === 'success') return 'border-green-400';
    if (type === 'alert' || type === 'error') return 'border-red-400';
    return 'border-green-400';
  }

  function dismiss(id: number) {
    items = items.filter((i) => i.id !== id);
  }

  function add(message: string, type = 'notice') {
    const id = ++nextId;
    items = [...items, { id, type, message }];
    setTimeout(() => dismiss(id), 3000);
  }

  onMount(() => {
    // Mount Rails flash items
    let parsed: { type: string; message: string }[] = [];
    try { parsed = JSON.parse(flashes); } catch (e) { console.error('Failed to parse flashes', e); }
    for (const f of parsed) add(f.message, f.type);

    // Listen for programmatic flash requests from anywhere in the app
    const handler = ({ message, type }: { message: string; type?: string }) => add(message, type);
    eventBus.on('flash-trigger', handler);
    return () => eventBus.off('flash-trigger', handler);
  });
</script>

<div class="flex fixed inset-x-0 top-0 z-50 flex-col items-end py-6 px-4 pointer-events-none sm:p-6">
  {#each items as item (item.id)}
    <div
      in:fly={{ x: 100, duration: 400 }}
      out:fade={{ duration: 300 }}
      class="relative w-full max-w-sm px-4 py-3 mb-2 text-neutral-900 bg-white border-l-4 {borderColor(item.type)} rounded shadow-lg pointer-events-auto"
    >
      <div class="p-2">
        <div class="flex items-start">
          <div class="ml-3 w-0 flex-1 pt-0.5">
            <div class="text-sm font-normal leading-5">
              <div class="text-neutral-900">{item.message}</div>
            </div>
          </div>
          <div class="flex flex-shrink-0 ml-4">
            <button
              on:click={() => dismiss(item.id)}
              class="inline-flex text-neutral-500 focus:outline-none"
            >
              <bt-icon icon="X" iconClass="w-5 h-5"></bt-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  {/each}
</div>
